module.exports = __webpack_public_path__ + "media/images/pinwheel-8b34d56c1025a5e8157433e4be0b09e5d7390a5faa2d38d84d600b79f261b783.jpg";